<template>
  <div class="mit-reserve-now"><!-- default all to 1 but override sm and larger to 8 -->
    <v-sheet :height="height">
      <v-calendar class="pb-20" ref="cal" v-model="calendarValue" :type="calendarType" color="primary" :events="events">
        <template v-slot:day-label-header="{ date, day, week }">
            <!-- <v-btn :disabled="prevDateDisabled" style="min-width:0px;" class="ma-1 mr-5" outlined icon color="primary" @click="prevDate()"><</v-btn> -->
            <v-btn style="min-width:0px;" class="ma-1 mr-5" outlined icon color="primary" @click="prevDate()"><</v-btn>
            <span>{{day}}</span>
            <v-btn style="min-width:0px" class="ma-1 ml-5" outlined icon color="primary" @click="nextDate()">></v-btn>
        </template>
        <template v-slot:day-body="{ date, week }">
          <div
            class="v-current-time"
            :class="{ first: date === week[0].date }"
            :style="{ top: nowY }"
          ></div>
        </template>
      </v-calendar>
    </v-sheet>
  </div>
</template>

<script>
  import moment from 'moment';

export default {
  name: 'BaseMitCalendar',
  components: {
  },
  props: {
      height:{
          default () {
              return 400;
          },
          type: Number
      },
      calendarType:{
          default () {
              return 'day';
          },
          type: String
      },
      events: Array,
      focusTime:{
          default () {
              return moment().format('hh:mm A');
          },
          type: String
      },
      calendarDate:{
          default () {
              return moment();
          },
          type: Object
      },
  },
  data: function() {
    return {
        mounted:false,
        calendarValue:null,
        time:null
    }
  },
  watch: {
      focusTime(newVal, oldVal) {
          this.time = moment(newVal, 'hh:mm A');
          this.setFocusTime(this.time)
      },
      calendarDate(newVal, oldVal) {
          this.calendarValue = moment(newVal).toDate();
      }
  },
  created(){
    this.calendarValue = moment(this.calendarDate).toDate();
  },
  computed: {
        prevDateDisabled(){
            return new moment(this.calendarValue).isSameOrBefore(new moment(), 'day')
        },
        // nextDateEnabled(){
        //     return new moment(this.calendarValue).isSameOrAfter(this.calendarDate, 'day')
        // },
      cal () {
        return this.mounted ? this.$refs.cal : null
      },
      nowY () {
        return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
      },
  },
  mounted() {
      this.mounted = true;
      this.time = moment(this.focusTime, 'hh:mm A');
      this.setFocusTime(this.time);
  },
  methods : {
        nextDate(){
            this.calendarValue = moment(this.calendarValue).add(1, 'days').toDate();
        },
        prevDate(){
            this.calendarValue = moment(this.calendarValue).subtract(1, 'days').toDate();
        },
        setFocusTime (momentTime) {
            this.cal.scrollToTime(momentTime.format("HH:mm"));//24 hour time
        }
  }
}
</script>

<style lang="scss" scoped>
    // this is for the calendar current time line
    .v-current-time {
      height: 2px;
      background-color: #ea4335;
      position: absolute;
      left: -1px;
      right: 0;
      pointer-events: none;

      &.first::before {
        content: '';
        position: absolute;
        background-color: #ea4335;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-top: -5px;
        margin-left: -6.5px;
      }
  }
</style>
